module.exports = __webpack_public_path__ + "static/media/waving-emoji.b5a04d1f.svg";